module.exports = __webpack_public_path__ + "img/Apple Music.55dd5816.svg";